var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportFt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7904 36.6092C40.7904 41.9532 36.2411 46.2854 30.6292 46.2854C25.0173 46.2854 20.468 41.9532 20.468 36.6092C20.468 31.2653 25.0173 26.9331 30.6292 26.9331C36.2411 26.9331 40.7904 31.2653 40.7904 36.6092Z",
    fill: "#54DFAC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.285 31.1221L35.3083 32.0964L31.4899 35.7325L30.4667 34.7582L34.285 31.1221Z",
    fill: "#00A377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0463 30.3978C35.3289 30.1288 35.787 30.1288 36.0695 30.3978C36.3521 30.6669 36.3521 31.1031 36.0695 31.3722L34.5472 32.8219C34.2646 33.091 33.8065 33.091 33.5239 32.8219C33.2414 32.5528 33.2414 32.1166 33.5239 31.8475L35.0463 30.3978Z",
    fill: "#00A377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7026 36.2448C34.7026 38.2488 32.9966 39.8733 30.8922 39.8733C28.7877 39.8733 27.0817 38.2488 27.0817 36.2448C27.0817 34.2408 28.7877 32.6162 30.8922 32.6162C32.9966 32.6162 34.7026 34.2408 34.7026 36.2448Z",
    fill: "#007C6B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5473 13.0249H35.7085V22.0963H25.5473V13.0249Z",
    fill: "#00D084"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5473 11.6584C25.5473 10.7425 26.327 10 27.2888 10H33.967C34.9288 10 35.7085 10.7425 35.7085 11.6584V14.3892C35.7085 15.3051 34.9288 16.0476 33.967 16.0476H27.2888C26.327 16.0476 25.5473 15.3051 25.5473 14.3892V11.6584Z",
    fill: "#00D084"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0223 16.9805L51.2784 23.7543L45.9433 28.9365L38.6873 22.1627L44.0223 16.9805Z",
    fill: "#00D084"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5815 16.4376C45.2548 15.7836 46.3574 15.7732 47.0442 16.4144L51.813 20.8663C52.4999 21.5075 52.5108 22.5574 51.8375 23.2114L50.7191 24.2978C50.0458 24.9518 48.9432 24.9623 48.2564 24.3211L43.4875 19.8692C42.8007 19.228 42.7897 18.178 43.463 17.524L44.5815 16.4376Z",
    fill: "#00D084"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6667 49.3961C38.0963 49.3961 43.9796 43.787 43.9796 37.0303C43.9796 30.2736 38.0963 24.6645 30.6667 24.6645C23.2371 24.6645 17.3538 30.2736 17.3538 37.0303C17.3538 43.787 23.2371 49.3961 30.6667 49.3961ZM30.6667 53.542C40.4237 53.542 48.3333 46.1495 48.3333 37.0303C48.3333 27.9111 40.4237 20.5186 30.6667 20.5186C20.9096 20.5186 13 27.9111 13 37.0303C13 46.1495 20.9096 53.542 30.6667 53.542Z",
    fill: "#001574"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportFt);
export default __webpack_public_path__ + "static/media/reportFt.b2e24b7361124ca643c51ed6c3807d46.svg";
export { ForwardRef as ReactComponent };